import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePwaInstallContext } from '../context/PwaInstallContext';
import { isAndroidDevice } from '../pwa/pwaInstallUtils';
import './pwa-install.css';

function InstallAppIcon() {
  return (
    <svg
      className="pwa-install-drawer-btn__icon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden
    >
      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
      <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
    </svg>
  );
}

/** Mobile drawer install — native prompt on Android when available; guided steps otherwise. */
export default function PwaInstallNavItem({ onAfterClick }) {
  const { pathname } = useLocation();
  const { canShowInstallOffer, runInstallAction } = usePwaInstallContext();
  const label = isAndroidDevice() ? 'Install app' : 'Add to home screen';

  if (pathname.startsWith('/admin') || !canShowInstallOffer) return null;

  return (
    <div className="pwa-install-drawer-action">
      <button
        type="button"
        className="pwa-install-drawer-btn"
        onClick={(event) => {
          onAfterClick?.(event);
          runInstallAction();
        }}
      >
        <InstallAppIcon />
        <span>{label}</span>
      </button>
    </div>
  );
}
